import React from 'react';
import { Box, IconButton, Typography, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CommentThread, CommentThreadProps } from './CommentThread';
import { IFeedComment } from '../../redux/activity/types';

interface CommentMobileRepliesProps extends Omit<CommentThreadProps, 'comment'> {
    parent: IFeedComment;
    onBack: () => void;
}

export const CommentMobileReplies: React.FC<CommentMobileRepliesProps> = ({
    parent,
    onBack,
    onLike,
    onReply,
    onEdit,
    onDelete,
    activeReplyId,
    onSetActiveReply,
    loadMoreReplies,
    fetchingMoreReplies,
    ...props
}) => (
    <Box
        sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            bgcolor: 'background.paper',
            zIndex: 1300,
            p: 2,
        }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
            <IconButton onClick={onBack}>
                <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6">Replies</Typography>
        </Stack>
        <Stack spacing={2}>
            {parent.replies?.map(reply => (
                <CommentThread
                    key={reply._id}
                    comment={reply}
                    onLike={onLike}
                    onReply={onReply}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    isMobile
                    depth={1}
                    activeReplyId={activeReplyId}
                    onSetActiveReply={onSetActiveReply}
                    loadMoreReplies={loadMoreReplies}
                    fetchingMoreReplies={fetchingMoreReplies}
                    {...props}
                />
            ))}
        </Stack>
    </Box>
);
